import * as XLSX from 'xlsx';
import { useEffect } from 'react';
import Spin from 'components/spin';
import { saveAs } from 'file-saver';
import { toast } from 'react-toastify';
import { Button } from '@mui/material';
import { CiExport } from 'react-icons/ci';

type Prop = {
  apiData?: any;
  fileName?: string;
  expoDisable?: boolean;
  expoHidden?: boolean;
  expoLoad?: boolean;
  setReload?: (e: boolean) => void;
};
export const ExportToExcel = ({
  apiData,
  fileName,
  expoDisable,
  expoHidden,
  expoLoad,
  setReload,
}: Prop) => {
  const fileType =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';

  const exportToExcel = (apiData: any, fileName: any) => {
    if (apiData.length === 0) {
      return toast.warn('не могу экспортировать');
    }
    const ws = XLSX.utils.json_to_sheet(apiData);
    const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    const data = new Blob([excelBuffer], { type: fileType });
    saveAs.saveAs(data, fileName + fileExtension);
  };

  const handleChange = () => {
    if (expoDisable) {
      return;
    }
    setReload?.(true);
  };

  useEffect(() => {
    if (apiData.length !== 0) {
      exportToExcel(apiData, fileName);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [apiData]);

  return (
    <Button
      disabled={expoLoad}
      onClick={handleChange}
      id='export'
      aria-label='export'
      sx={{
        padding: 0,
        background: 'transparent !important',
        minWidth: '20px',
        display: expoHidden ? 'none' : 'flex',
      }}>
      {expoLoad ? <Spin /> : <CiExport size={35} color={expoDisable ? '#BEBFC1' : '#005AA9'} />}
    </Button>
  );
};
